<template>
  <div class="payment-container">
    <!-- 页面头部 + 面包屑 -->
    <div class="page-header">
      <div class="header-left">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/Welcome' }">
            <i class="el-icon-s-home"></i> 首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>付款单列表</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="title-wrapper">
          <h2 class="page-title">付款单列表</h2>
          <span class="badge-count">{{ total }}</span>
        </div>
      </div>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-row">
      <div class="stat-card">
        <div class="stat-icon icon-total">
          <i class="el-icon-document"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">总付款单</div>
          <div class="stat-number">{{ total }}</div>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-icon icon-amount">
          <i class="el-icon-money"></i>
        </div>
        <div class="stat-info">
          <div class="stat-label">当前页金额(元)</div>
          <div class="stat-number">{{ pageAmount | numberFormat }}</div>
        </div>
      </div>
    </div>

    <!-- 筛选卡片 -->
    <el-card class="filter-card" shadow="never">
      <div class="filter-header">
        <i class="el-icon-search filter-icon"></i>
        <span class="filter-title">筛选查询</span>
      </div>
      <el-form size="small" :inline="true" :model="searchForm" ref="searchFormRef" class="filter-form">
        <div class="filter-row">
          <el-form-item label="编码">
            <el-input
              v-model="searchForm.sn"
              placeholder="请输入编码"
              clearable
              prefix-icon="el-icon-document"
            ></el-input>
          </el-form-item>
          <el-form-item label="名称">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入名称"
              clearable
              prefix-icon="el-icon-search"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input
              v-model="searchForm.shop_name"
              placeholder="请输入客户名称"
              clearable
              prefix-icon="el-icon-user"
            ></el-input>
          </el-form-item>
          <el-form-item label="业务员">
            <el-input
              v-model="searchForm.operator_name"
              placeholder="请输入业务员"
              clearable
              prefix-icon="el-icon-s-custom"
            ></el-input>
          </el-form-item>
          <el-form-item label="费用类别">
            <el-select
              v-model="searchForm.dic_id"
              placeholder="请选择类别"
              clearable
              style="width: 180px;"
            >
              <el-option
                v-for="item in dicList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="action-buttons">
            <el-button type="primary" icon="el-icon-search" @click="searchSubmit" class="search-btn">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch" class="reset-btn">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>

    <!-- 表格卡片 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-header-left">
          <i class="el-icon-s-data table-icon"></i>
          <span class="table-title">付款单列表</span>
          <el-tag type="info" size="small" effect="plain">共 {{ total }} 条记录</el-tag>
        </div>
        <div class="table-header-right">
          <div class="action-btn-group">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="addData">新增</el-button>
            <el-button type="success" size="small" icon="el-icon-edit" :disabled="isEdit" @click="goEdit">修改选中</el-button>
            <el-button type="danger" size="small" icon="el-icon-delete" :disabled="isDel" @click="handleDeleteSelected">删除</el-button>
            <el-button type="warning" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
          </div>
          <el-tooltip content="刷新数据" placement="top">
            <el-button icon="el-icon-refresh" size="small" circle @click="getList"></el-button>
          </el-tooltip>
        </div>
      </div>

      <el-table
        ref="multipleTable"
        :data="tableData"
        size="small"
        stripe
        border
        style="width: 100%"
        :row-class-name="tableRowClassName"
        v-loading="loading"
        element-loading-text="数据加载中..."
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center">
          <template slot-scope="scope">
            <span class="index-badge">{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="编码" width="120" prop="sn" show-overflow-tooltip></el-table-column>
        <el-table-column label="合同名称" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.contract ? scope.row.contract.name : '--' }}</template>
        </el-table-column>
        <el-table-column label="客商" width="180" prop="payee_name" show-overflow-tooltip></el-table-column>
        <el-table-column label="付款日期" width="110" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.pay_time | timeFormat }}</template>
        </el-table-column>
        <el-table-column label="金额" width="100" align="right" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="amount-text">¥{{ scope.row.amount | numberFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column label="凭证号" width="100" prop="num" show-overflow-tooltip></el-table-column>
        <el-table-column label="费用类型" width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.category ? scope.row.category.name : '--' }}</template>
        </el-table-column>
        <el-table-column label="经办人" width="100" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.operator ? scope.row.operator.name_cn : '--' }}</template>
        </el-table-column>
        <el-table-column label="部门" width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.department ? scope.row.department.name : '--' }}</template>
        </el-table-column>
        <el-table-column label="创建人" width="100" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.creator ? scope.row.creator.name_cn : '--' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="160" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.add_time | timeFormat }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <template slot-scope="scope">
            <el-dropdown trigger="click" size="small" @command="(cmd) => handleCommand(cmd, scope.row)">
              <span class="more-btn">
                <i class="el-icon-more"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-view" command="view">查看修改</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑弹框（原代码遗留的保司弹窗，实际未使用，保留但隐藏） -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="500px" class="alipay-dialog" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="small" label-position="right">
        <el-form-item label="保司名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入保司名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')" size="small">取消</el-button>
        <el-button type="primary" @click="submitForm('form')" size="small">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'pmtList',
  data() {
    return {
      loading: false,
      isDel: true,
      isEdit: true,
      multipleSelection: [],
      dicList: [],
      searchForm: {
        sn: '',
        name: '',
        shop_name: '',
        operator_name: '',
        dic_id: ''
      },
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      pageAmount: 0,
      showType: '',
      dialogFormVisible: false,
      title: '',
      form: { name: '' },
      rules: {
        name: [
          { required: true, message: '请输入保司名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在2-30个字符', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
    dateFormat(timestamp) {
      if (!timestamp) return '--'
      return moment(timestamp * 1000).format('YYYY-MM-DD')
    },
    timeFormat(timestamp) {
      if (!timestamp) return '--'
      return moment(timestamp * 1000).format('YYYY-MM-DD HH:mm:ss')
    },
    numberFormat(value) {
      if (value === undefined || value === null) return '0.00'
      return Number(value).toFixed(2)
    }
  },
  created() {
    this.showType = this.$route.query.showType
    this.getList()
    this.getDicList()
  },
  methods: {
    // 获取费用类别下拉
    getDicList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.findTree(param).then(res => {
        if (res.code === 200) {
          this.dicList = res.data.data || []
        }
      }).catch(err => console.log(err))
    },
    // 获取列表
    getList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        showType: this.showType,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        sn: this.searchForm.sn,
        name: this.searchForm.name,
        shop_name: this.searchForm.shop_name,
        operator_name: this.searchForm.operator_name,
        dic_id: this.searchForm.dic_id
      }
      this.$axios.findPaymentListP(param).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.data || []
          this.total = res.data.total || 0
          // 计算当前页总金额
          this.pageAmount = this.tableData.reduce((sum, item) => sum + (item.amount || 0), 0)
        } else {
          this.$message.error(res.msg || '数据加载失败')
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('网络异常，请稍后重试')
        console.log(err)
      })
    },
    // 搜索
    searchSubmit() {
      this.pageNum = 1
      this.getList()
    },
    // 重置搜索
    resetSearch() {
      this.searchForm = { sn: '', name: '', shop_name: '', operator_name: '', dic_id: '' }
      this.pageNum = 1
      this.getList()
    },
    // 分页
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.getList()
    },
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.getList()
    },
    // 表格选中
    handleSelectionChange(val) {
      this.multipleSelection = val
      const len = val.length
      this.isEdit = len !== 1
      this.isDel = len === 0
    },
    // 序号
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 新增
    addData() {
      this.$router.push('/pmtForm')
    },
    // 修改
    goEdit() {
      if (this.multipleSelection.length === 1) {
        this.$router.push({
          path: '/pmtForm',
          query: { id: this.multipleSelection[0].id }
        })
      } else {
        this.$message.warning('请选择一条数据修改')
      }
    },
    // 删除选中
    handleDeleteSelected() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm(`确定删除选中的 ${this.multipleSelection.length} 条付款单吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'alipay-message-box'
      }).then(async () => {
        // 批量删除（循环调用删除接口，实际可改为批量接口）
        let successCount = 0
        for (const item of this.multipleSelection) {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            id: item.id
          }
          try {
            const res = await this.$axios.paymentDel?.(param)
            if (res && res.code === 200) successCount++
          } catch (e) { console.error(e) }
        }
        if (successCount > 0) {
          this.$message.success(`成功删除 ${successCount} 条记录`)
          this.getList()
        } else {
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    // 更多操作 - 查看修改
    handleCommand(cmd, row) {
      if (cmd === 'view') {
        this.$confirm('您确定审核后生成业绩吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'alipay-message-box'
        }).then(() => {
          this.$router.push({
            path: '/costContractForm',
            query: { contract_id: row.id }
          })
        }).catch(() => {
          this.$message.info('已取消生成')
        })
      }
    },
    // 导出
    handleExport() {
      this.$message.info('导出功能开发中，实际可调用后端导出接口')
    },
    // 以下为原代码中未使用的弹窗方法，保留以兼容
    reset_dialogForm(formName) {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs[formName]?.resetFields()
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const param = {
            name: this.form.name,
            operator_id: sessionStorage.getItem('user_id'),
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token')
          }
          this.$axios.insuranceCorpSave(param).then(res => {
            if (res.code === 200) {
              this.$message.success(res.msg)
              this.dialogFormVisible = false
              this.getList()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 表格斑马纹
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row'
    }
  }
}
</script>

<style lang="scss" scoped>
// 支付宝风格变量
$primary-color: #1677ff;
$success-color: #00b42a;
$danger-color: #f53f3f;
$warning-color: #ff7d00;
$text-primary: #1f2d3d;
$text-regular: #4e5969;
$text-secondary: #86909c;
$border-color: #e5e6eb;
$bg-gray: #f7f8fa;
$card-shadow: 0 2px 8px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.02);

.payment-container {
  padding: 20px 24px;
  background: $bg-gray;
  min-height: calc(100vh - 84px);
}

/* 页面头部 */
.page-header {
  margin-bottom: 20px;
  .header-left {
    .el-breadcrumb {
      margin-bottom: 12px;
      ::v-deep .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: $text-secondary;
          font-size: 13px;
          &.is-link {
            color: $primary-color;
            &:hover { color: lighten($primary-color, 10%); }
          }
        }
        &:last-child .el-breadcrumb__inner {
          color: $text-primary;
          font-weight: 500;
        }
      }
    }
    .title-wrapper {
      display: flex;
      align-items: baseline;
      gap: 12px;
    }
    .page-title {
      margin: 0;
      font-size: 24px;
      font-weight: 600;
      color: $text-primary;
      letter-spacing: -0.3px;
    }
    .badge-count {
      display: inline-block;
      padding: 2px 10px;
      background: rgba($primary-color, 0.1);
      color: $primary-color;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 500;
    }
  }
}

/* 统计卡片 */
.stats-row {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  .stat-card {
    flex: 1;
    background: white;
    border-radius: 16px;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: $card-shadow;
    transition: all 0.2s ease;
    border: 1px solid transparent;
    &:hover {
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
      border-color: rgba($primary-color, 0.1);
    }
    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      &.icon-total { background: rgba($primary-color, 0.1); color: $primary-color; }
      &.icon-amount { background: rgba($success-color, 0.1); color: $success-color; }
    }
    .stat-info {
      flex: 1;
      .stat-label { font-size: 13px; color: $text-secondary; margin-bottom: 4px; }
      .stat-number { font-size: 28px; font-weight: 600; color: $text-primary; line-height: 1.2; }
    }
  }
}

/* 筛选卡片 */
.filter-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  box-shadow: $card-shadow;
  ::v-deep .el-card__body { padding: 20px 24px; }
  .filter-header {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid $border-color;
    .filter-icon { color: $primary-color; font-size: 18px; margin-right: 8px; }
    .filter-title { font-size: 15px; font-weight: 600; color: $text-primary; }
  }
  .filter-form {
    .filter-row {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      align-items: flex-end;
    }
    ::v-deep .el-form-item {
      margin-bottom: 0;
      .el-form-item__label { font-weight: 500; color: $text-regular; font-size: 13px; }
      .el-input__inner, .el-select .el-input__inner {
        border-radius: 8px;
        border-color: $border-color;
        transition: all 0.2s;
        &:focus {
          border-color: $primary-color;
          box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
        }
      }
    }
    .action-buttons {
      margin-left: auto;
      .search-btn, .reset-btn {
        border-radius: 20px;
        padding: 8px 20px;
        font-weight: 500;
      }
      .search-btn { background: $primary-color; border: none; &:hover { background: lighten($primary-color, 8%); } }
      .reset-btn { border-color: $border-color; color: $text-regular; &:hover { border-color: $primary-color; color: $primary-color; } }
    }
  }
}

/* 表格卡片 */
.table-card {
  border-radius: 16px;
  border: none;
  box-shadow: $card-shadow;
  ::v-deep .el-card__body { padding: 20px 24px; }
  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid $border-color;
    .table-header-left {
      display: flex;
      align-items: center;
      gap: 12px;
      .table-icon { color: $primary-color; font-size: 18px; }
      .table-title { font-size: 16px; font-weight: 600; color: $text-primary; }
      ::v-deep .el-tag { background: $bg-gray; border: none; color: $text-secondary; }
    }
    .table-header-right {
      display: flex;
      align-items: center;
      gap: 12px;
      .action-btn-group {
        display: flex;
        gap: 8px;
        .el-button {
          border-radius: 20px;
          padding: 6px 16px;
          font-weight: 500;
        }
      }
      .el-button--circle {
        color: $text-secondary;
        &:hover { color: $primary-color; background: rgba($primary-color, 0.05); }
      }
    }
  }
}

/* 表格样式 */
::v-deep .el-table {
  font-size: 13px;
  border-radius: 12px;
  overflow: hidden;
  th {
    background: $bg-gray !important;
    color: $text-secondary;
    font-weight: 500;
    padding: 12px 0;
    border-bottom: 1px solid $border-color;
  }
  td {
    padding: 14px 0;
    border-bottom: 1px solid $border-color;
  }
  .even-row { background: #ffffff; }
  .odd-row { background: #fbfbfc; }
  .hover-row > td { background: rgba($primary-color, 0.02) !important; }
}
.amount-text {
  color: $danger-color;
  font-weight: 500;
}
.index-badge {
  display: inline-block;
  width: 26px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  background: $bg-gray;
  color: $text-secondary;
  border-radius: 13px;
  font-size: 12px;
}
.more-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 14px;
  cursor: pointer;
  color: $text-secondary;
  transition: all 0.2s;
  &:hover { background: rgba($text-secondary, 0.1); color: $primary-color; }
  i { font-size: 16px; }
}

/* 分页 */
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  margin-top: 16px;
  border-top: 1px solid $border-color;
  ::v-deep .el-pagination {
    .el-pagination__total, .el-pagination__jump { color: $text-secondary; font-size: 13px; }
    .btn-prev, .btn-next, .el-pager li {
      border-radius: 8px;
      margin: 0 4px;
      font-weight: 500;
      &:hover { color: $primary-color; }
    }
    .el-pager li.active { background: $primary-color; color: white; &:hover { background: lighten($primary-color, 8%); } }
  }
}

/* 弹窗样式（保留原弹窗样式） */
::v-deep .alipay-dialog {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    .el-dialog__header { border-bottom: 1px solid $border-color; padding: 20px 24px; .el-dialog__title { font-size: 18px; font-weight: 600; } }
    .el-dialog__body { padding: 24px; }
    .el-dialog__footer { border-top: 1px solid $border-color; padding: 16px 24px; }
  }
}

::v-deep .alipay-message-box {
  border-radius: 16px;
  .el-message-box__header { padding-top: 20px; .el-message-box__title { font-weight: 600; } }
  .el-message-box__btns button { border-radius: 20px; padding: 8px 20px; }
}

/* 响应式 */
@media (max-width: 1200px) {
  .stats-row { flex-direction: column; gap: 12px; .stat-card { padding: 16px 20px; } }
  .filter-form .filter-row {
    flex-direction: column;
    align-items: stretch;
    .el-form-item { width: 100%; }
    .action-buttons { margin-left: 0; display: flex; gap: 12px; .el-button { flex: 1; text-align: center; } }
  }
  .table-header {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 12px;
    .table-header-right { width: 100%; justify-content: space-between; }
  }
}
@media (max-width: 768px) {
  .payment-container { padding: 16px; }
  .table-card ::v-deep .el-card__body { padding: 16px; }
}
</style>